import { FC, SVGProps } from 'react';

const PhoneOutlined: FC<SVGProps<SVGSVGElement>> = ({
  height = 16,
  width = 16,
  ...props
}) => {
  return (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 17"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.68766 8.81501C10.3471 11.4737 10.9504 8.39789 12.6436 10.09C14.276 11.7219 15.2142 12.0489 13.146 14.1166C12.8869 14.3248 11.2409 16.8296 5.45624 11.0465C-0.329148 5.26275 2.17423 3.61504 2.38248 3.35605C4.45575 1.28265 4.77708 2.22634 6.4095 3.8583C8.10275 5.55108 5.02828 6.15636 7.68766 8.81501Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
  )
};
export default PhoneOutlined;
